<template>
	<div class="max-w-2xl mt-10 mx-auto px-4 sm:px-6 lg:px-8">
	<form @submit.prevent="submit" class="space-y-8 divide-y divide-gray-200">
		<div class="space-y-8 divide-y divide-gray-200">
			<div>

				<div v-if="hasPasted" :class="[doesClipboardContainGoogleElement ? 'bg-green-200' : 'bg-red-200']" class="mb-4 p-4 rounded">
					<span v-if="hasPasted && doesClipboardContainGoogleElement">
						Valid paste!
					</span>
					<span v-else>
						Paste is NOT valid!
					</span>
				</div>

				<div>
					<h3 class="text-lg leading-6 font-medium text-gray-900">Create New Template</h3>
					<p class="mt-1 text-sm text-gray-500">Use this form to add a new template to the database.</p>
				</div>

				<div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

					<div class="sm:col-span-3">
						<label for="formalname" class="block text-sm font-medium text-gray-700"> Formal Name </label>
						<div class="mt-1">
							<input v-model="form.formalname" type="text" name="formalname" id="formalname" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
						</div>
					</div>

					<div class="sm:col-span-3">
						<label for="shortname" class="block text-sm font-medium text-gray-700"> Short Name </label>
						<div class="mt-1">
							<input v-model="form.shortname" type="text" name="shortname" id="shortname" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
						</div>
					</div>

					<div class="sm:col-span-3">
						<label for="color" class="block text-sm font-medium text-gray-700"> Color (HEX) </label>
						<div class="mt-1">
							<input v-model="form.color" type="text" name="color" id="color" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
						</div>
					</div>

					<div class="sm:col-span-6">
						<label for="description" class="block text-sm font-medium text-gray-700"> Description </label>
						<div class="mt-1">
							<textarea v-model="form.description" id="description" name="description" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md" />
						</div>
						<p class="mt-2 text-sm text-gray-500">OPTIONAL - add a description of this template.</p>
					</div>

					<div class="sm:col-span-6">
						<label for="collection" class="block text-sm font-medium text-gray-700">Collection</label>
						<select v-model="form.collection" id="collection" name="collection" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
							<option selected="">iconoir</option>
							<option>heroicons</option>
						</select>
					</div>

					<div class="sm:col-span-6">
						<label for="type" class="block text-sm font-medium text-gray-700">Template Type</label>
						<select v-model="form.type" id="type" name="type" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
							<option selected="">icon</option>
							<option>slide-stub</option>
						</select>
					</div>

					<div class="sm:col-span-6">
						<label for="classification" class="block text-sm font-medium text-gray-700"> Classification </label>
						<div class="mt-1">
							<input v-model="form.classification" type="text" name="classification" id="classification" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
						</div>
					</div>


					<div class="sm:col-span-6">
						<label for="fileupload" class="block text-sm font-medium text-gray-700"> Icon or Preview Image </label>
						<div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
							<div class="space-y-1 text-center">
								<svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
									<path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<div class="flex text-sm text-gray-600">
									<label for="fileupload" class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
										<span>Upload a file</span>
										<input @input="form.fileupload = $event.target.files[0]" id="fileupload" name="fileupload" type="file" class="sr-only" />
									</label>
									<p class="pl-1">or drag and drop</p>
								</div>
								<p class="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
							</div>
						</div>
					</div>


<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard1type" class="block text-sm font-medium text-gray-700"> Clipboard 1 Type </label>-->
<!--						<div class="mt-1">-->
<!--							<input v-model="form.clipboard1type" type="text" name="clipboard1type" id="clipboard1type" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--					</div>-->

<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard1" class="block text-sm font-medium text-gray-700"> Clipboard 1 </label>-->
<!--						<div class="mt-1">-->
<!--							<textarea v-model="form.clipboard1" id="clipboard1" name="clipboard1" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--						<p class="mt-2 text-sm text-gray-500">Upload the raw JSON associated with the clipboard of this template</p>-->
<!--					</div>-->

<!--					<hr>-->

<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard2type" class="block text-sm font-medium text-gray-700"> Clipboard 2 Type </label>-->
<!--						<div class="mt-1">-->
<!--							<input v-model="form.clipboard2type" type="text" name="clipboard2type" id="clipboard2type" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--					</div>-->

<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard2" class="block text-sm font-medium text-gray-700"> Clipboard 2 </label>-->
<!--						<div class="mt-1">-->
<!--							<textarea v-model="form.clipboard2" id="clipboard2" name="clipboard2" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--						<p class="mt-2 text-sm text-gray-500">OPTIONAL - Upload the raw JSON associated with the clipboard of this template</p>-->
<!--					</div>-->

<!--					<hr>-->

<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard3type" class="block text-sm font-medium text-gray-700"> Clipboard 3 Type </label>-->
<!--						<div class="mt-1">-->
<!--							<input v-model="form.clipboard3type" type="text" name="clipboard3type" id="clipboard3type" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--					</div>-->

<!--					<div class="sm:col-span-6">-->
<!--						<label for="clipboard3" class="block text-sm font-medium text-gray-700"> Clipboard 3 </label>-->
<!--						<div class="mt-1">-->
<!--							<textarea v-model="form.clipboard3" id="clipboard3" name="clipboard3" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md" />-->
<!--						</div>-->
<!--						<p class="mt-2 text-sm text-gray-500">OPTIONAL - Upload the raw JSON associated with the clipboard of this template</p>-->
<!--					</div>-->

					<hr>

					<div class="relative flex items-start sm:col-span-6">
						<div class="flex items-center h-5">
							<input v-model="form.premium" id="premium" name="premium" type="checkbox" checked class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded" />
						</div>
						<div class="ml-3 text-sm">
							<label for="premium" class="font-medium text-gray-700">Premium?</label>
							<p class="text-gray-500">Designate this template as a premium addition.</p>
						</div>
					</div>




				</div>
			</div>


		</div>

		<div class="pt-5">
			<div class="flex justify-end pb-12">
				<button type="submit" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Save</button>
			</div>
		</div>
	</form>
	</div>
</template>
<script setup>
import {useForm} from "@inertiajs/vue3";
import {computed, ref} from "vue";

document.addEventListener('paste', function(e){

	const output = extractData(e.clipboardData)
		.then((response) => {
			console.log(response.types)
			clipboard.value = response.types
			return response.types
		})

	hasPasted.value = true;
});


const doesClipboardContainGoogleElement = computed(() => {
	let output = clipboard.value.filter(el => el.type.includes("application/x-vnd.google"));
	return output.length > 0;
})

async function extractData(data) {
	if (!data) {
		return undefined;
	}

	const file_info = file =>
		file
			? {
				name: file.name,
				size: file.size,
				type: file.type,
				url: URL.createObjectURL(file)
			}
			: null;

	if (data instanceof DataTransfer) {
		return {
			type: 'DataTransfer',
			types: Array.from(data.types).map(type => ({
				type,
				data: data.getData(type)
			})),
			items: data.items
				? Array.from(data.items).map(item => ({
					kind: item.kind,
					type: item.type,
					as_file: file_info(item.getAsFile())
				}))
				: null,
			files: data.files ? Array.from(data.files).map(file_info) : null
		};
	}

	if (data instanceof ClipboardItem) {
		return {
			type: 'ClipboardItem',
			types: await Promise.all(
				Array.from(data.types).map(async type => {
					const blob = await data.getType(type);
					return {
						type: type,
						data: blob.type.match(/^text\//)
							? await blob.text()
							: file_info(blob)
					};
				})
			)
		};
	}
	return undefined;
}


const clipboard = ref([]);
const hasPasted = ref(false);

const form = useForm({
	formalname: '',
	shortname: '',
	description: '',
	color: '',
	collection: 'iconoir',
	classification: '',
	type: 'icon',
	fileupload: null,
	clipboard1type: '',
	clipboard1: '',
	clipboard2type: null,
	clipboard2: null,
	clipboard3type: null,
	clipboard3: null,
	premium: false
});

function submit() {
	form.post('/create')
}

</script>